const socialMediaConfig = [
  {
    key: 'linkedin',
    src: 'https://assets.bairesdev.com/image/upload/www/static/LinkedIn_ehfmoy.svg',
    alt: 'Linkedin',
    defaultUrl: 'https://www.linkedin.com/company/bairesdev/',
  },
  {
    key: 'xTwitter',
    src: 'https://assets.bairesdev.com/image/upload/www/static/X_messv5.svg',
    alt: 'X',
    defaultUrl: 'https://x.com/bairesdev/',
  },
  {
    key: 'instagram',
    src: 'https://assets.bairesdev.com/image/upload/www/static/Instagram_m9x6wt.svg',
    alt: 'Instagram',
    defaultUrl: 'https://www.instagram.com/bairesdev/',
  },
  {
    key: 'youtube',
    src: 'https://assets.bairesdev.com/image/upload/www/static/Youtube_nuqudj.svg',
    alt: 'Youtube',
    defaultUrl: 'https://www.youtube.com/@bairesdev/',
  },
] as const;

export default socialMediaConfig;
